import { Link, useLocation, useNavigate } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import { useEffect, useState } from 'react';
import { getFacebookUrl, getLinkedinUrl, getTwitterUrl } from "@phntms/react-share";
import './subsection-footer.scss';
import circlearrow from './../../assets/images/circle-arrow.svg';
import facebook from './../../assets/images/facebook.svg';
import linkedin from './../../assets/images/linkedin.svg';
import twitter from './../../assets/images/twitter.svg';
import mail from './../../assets/images/mail.svg';
import References from './../../components/references/references';

export default function SubsectionFooter(props) {
  const location = useLocation();
  const navigate = useNavigate();

  // Define your tab routes here
  const tabs = [
    'usage',
    'planning',
    'integration',
    'metrics',
    'future',
  ];

  //console.log(props.currentSection);

  // Find the current tab index in the array
  let currentTabIndex = tabs.indexOf(location.pathname.split('/').pop()) === -1 ? 0 : tabs.indexOf(location.pathname.split('/').pop())
  let hasPrev = currentTabIndex > 0;
  let hasNext = currentTabIndex < tabs.length - 1;

  let prevTab = hasPrev ? tabs[currentTabIndex - 1] : null;
  let nextTab = hasNext ? tabs[currentTabIndex + 1] : null;

  const [prevLink, setPrevLink] = useState("");
  const [nextLink, setNextLink] = useState("");

  useEffect(() => {

    currentTabIndex = tabs.indexOf(location.pathname.split('/').pop()) === -1 ? 0 : tabs.indexOf(location.pathname.split('/').pop())
    hasPrev = currentTabIndex > 0;
    hasNext = currentTabIndex < tabs.length - 1;

    prevTab = hasPrev ? tabs[currentTabIndex - 1] : null;
    nextTab = hasNext ? tabs[currentTabIndex + 1] : null;
       
      if (hasPrev) {
        if (currentTabIndex === 1) { 
          setPrevLink(`/${location.pathname.split('/')[1]}#subnav`);
          
        } else {
          setPrevLink(`/${location.pathname.split('/')[1]}/${prevTab}#subnav`);
          
        }
      }

      if (hasNext) {
        setNextLink(`/${location.pathname.split('/')[1]}/${nextTab}#subnav`);
      }

  }, [location.pathname]);

  return (
    <>
      <div className="subsection-footer">

{!props.keyTakeaways && 
        <div className="key-motivator-module">
          <props.KeyMotivator />
        </div>
}

    {(!props.keyTakeaways && props.currentSection != "Health") && 
      <div className="summary-module">
        <props.Summary />
      </div>
    }

    {(!props.keyTakeaways && props.currentSection == "Health") &&
    <div className="summary-module">
      {props.Summary}
    </div>
    }

{!props.keyTakeaways && 
        <div className="subsection-nav">

       {hasPrev && <NavHashLink className='btn-arrow btn-prev' to={prevLink} end><span className='circle'></span> <span>Explore more <br />{props.currentSection} <span className='tab-name'>{prevTab}</span> </span></NavHashLink>}
       {hasNext && <NavHashLink className='btn-arrow btn-next' to={nextLink} ><span>Explore more <br />{props.currentSection} <span className='tab-name'>{nextTab}</span> </span><span className='circle'></span></NavHashLink>}
        </div>
}

        <div className="share-explore-row">
          <div className="share-report-module">
            <p>Share the report</p>
            <ul className='social-networks'>
              <li><a aria-label="Share on Facebook" href={getFacebookUrl({ url: "http://www.uspsdelivers.com/" })}><img src={facebook}/></a></li>
              <li><a aria-label="Share on Twitter" href={getTwitterUrl({ url: "http://www.uspsdelivers.com/" })}><img src={twitter}/></a></li>
              <li><a aria-label="Share on LinkedIn" href={getLinkedinUrl({ url: "http://www.uspsdelivers.com/" })}><img src={linkedin}/></a></li>
              <li><a href={`mailto:?subject=USPS Direct Mail Insights&body=Check out this article!`} title="Share via Email"><img src={mail}/></a></li>
            </ul>
          </div>

          <div className="explore-more-module">
            <p>Explore More From </p>
            <a href="/../">USPS Delivers</a>
          </div>
        </div>

      </div>

      <References references={props.references} />

    </>

  );
}
